import React from 'react';
import './About.css';

export default function About() {
  const stats = [
    { number: '12K+', label: 'Happy travellers' },
    { number: '850+', label: 'Stays listed' },
    { number: '40+', label: 'Cities covered' },
    { number: '4.8★', label: 'Avg. rating' },
  ];

  return (
    <section className="block" id="about">
      <div className="container">
        <div className="about-grid">
          <div className="imgslot" data-label="assets/about.jpg">
            <img src="/assets/1000007.jpg" alt="About Ammy Services" onError={(e) => (e.target.style.display = 'none')} />
          </div>
          <div>
            <h2>About Ammy Services</h2>
            <p>
              Ammy Services is your single window for travel across India — book hotels and homestays, grab flight deals,
              reserve cabs and airport pickups, and plan complete trips with people who know the ground. We started with
              one idea: make travel booking simple, transparent and genuinely local.
            </p>
            <p>
              From a beach shack in Goa to a heritage haveli in Jaipur, we handpick stays and partners so your trip just
              works — at honest prices, with support that actually answers.
            </p>
            <div className="stats">
              {stats.map((stat, idx) => (
                <div key={idx} className="stat">
                  <div className="n">{stat.number}</div>
                  <div className="l">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
